<template>
  <v-app light class="base">
    <v-snackbar
      :timeout="5000"
      v-model="snackbar.isOpen"
      :right="true"
      :bottom="true"
      :color="snackbar.type"
    >
      {{ snackbar.text }}
    </v-snackbar>
    <v-toolbar app fixed clipped-left class="contrast" v-if="$vuetify.breakpoint.mdAndDown">
      <v-toolbar-side-icon @click.stop="switchNavigationDrawer"></v-toolbar-side-icon>
      <v-toolbar-title>{{$route.name}}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <NavigationDrawer />
      <router-view :key="$router.currentRoute.name"></router-view>
    </v-content>
  </v-app>
</template>

<script>
import NavigationDrawer from './components/partials/NavigationDrawer.vue'
import { SET_SNACKBAR, SET_NAVIGATION_DRAWER } from './store/mutations'

export default {
  name: 'app',
  components: {
    NavigationDrawer
  },
  data: () => ({
    categories: ['Bucket', 'User'],
    drawer: false
  }),
  computed: {
    snackbar: {
      get () {
        return this.$store.getters.snackbar
      }
    }
  },
  methods: {
    closeSnackbar () {
      this.$store.commit(SET_SNACKBAR, {
        isOpen: false
      })
    },
    switchNavigationDrawer () {
      this.$store.commit(SET_NAVIGATION_DRAWER, !this.$store.getters.isNavigationDrawerOpened)
    }
  }
}
</script>

<style lang="postcss" scoped>
.search-bar {
  display: flex;
  align-items: center;
}
</style>

<style lang="postcss">
.km-table {
  border-radius: 4px;
  width: 100%;

  & .v-datatable {
    background: transparent !important;

    & tbody tr:hover {
      background: transparent !important;
    }

    & .v-datatable__actions {
      background: transparent !important;
    }

    & th,
    & td {
      font-size: 1rem;
    }

    & td.clickable {
      cursor: pointer;
      transition: background 0.4s;
      &:hover {
        background: rgba(0, 0, 0, 0.5);
      }
    }
  }
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
  background-color: transparent;
}

::-webkit-scrollbar {
  width: 3px;
  height: 5px;
}

::-webkit-scrollbar-thumb {
  background-color: #01cea2;
  border-radius: 2px;
}

.alert {
  position: fixed;
  top: 0;
  left: 0;
}
</style>
